import React from "react";
import ReactDOM from "react-dom/client";
// import './index.css';
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { store } from "./app/store";
import { Provider } from "react-redux";
// import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import "./tailwindcss.css";

// if (process.env.NODE_ENV === "production") disableReactDevTools();

const GA_ID = "G-L79HL59W9Y";

(function loadGtag() {
  const script1 = document.createElement("script");
  script1.setAttribute("async", "");
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script1);

  const script2 = document.createElement("script");
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', '${GA_ID}');
  `;
  document.head.appendChild(script2);
})();

// (function loadFacebookPixel() {
//   !(function (f, b, e, v, n, t, s) {
//     if (f.fbq) return;
//     n = f.fbq = function () {
//       n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
//     };
//     if (!f._fbq) f._fbq = n;
//     n.push = n;
//     n.loaded = true;
//     n.version = "2.0";
//     n.queue = [];
//     t = b.createElement(e);
//     t.async = true;
//     t.src = v;
//     s = b.getElementsByTagName(e)[0];
//     s.parentNode.insertBefore(t, s);
//   })(
//     window,
//     document,
//     "script",
//     "https://connect.facebook.net/en_US/fbevents.js"
//   );

//   fbq("init", "649176604414742");
//   fbq("track", "PageView");
// })();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
